<template>
  <v-container>
    <v-row>
      <v-col>
        <v-icon color="#757575">mdi-calendar-blank-outline</v-icon> <span class="competition-date-time">{{entry.matchStartDate | moment("DD MMM YY")}}</span>
        <v-icon color="#757575">mdi-clock-outline</v-icon> <span class="competition-date-time">{{entry.matchStartDate | moment("HH:mm")}}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2" align="center">
        <ClubIcon 
          :name="entry.clubName"
          :shield="entry.ownClubShield"
          :ball="entry.ownClubBallColour"
        ></ClubIcon>
      </v-col>
      <v-col cols="10">
        <div>{{entry.matchName}}</div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ClubIcon from './ClubIcon';

export default {
  name: 'EntryHeader',
  props: ['entry'],
  components: {
    ClubIcon
  },
}
</script>
